export default __webpack_public_path__ + "static/media/red.6b252fe6.png";